import { MAX_LIST_DISPLAY_LENGTH } from '@wodi/domain';
import { z } from 'zod';

// Settings lists for the operations modules (docs/plans/phase3-operations-modules.md §0.1,
// ADR 0036). Each module serves and saves its own kinds under its own permissions.

export const operationsListItemSchema = z.object({
  code: z.string(),
  display: z.string(),
  active: z.boolean(),
});
export type OperationsListItemView = z.infer<typeof operationsListItemSchema>;

/** A whole list as Settings saves it, in the order shown. Codes are checked by the domain. */
export const saveOperationsListRequestSchema = z.object({
  items: z
    .array(
      z.object({
        code: z.string().trim().min(1).max(40),
        display: z.string().trim().min(1).max(MAX_LIST_DISPLAY_LENGTH),
        active: z.boolean(),
      }),
    )
    .min(1)
    .max(100),
});
export type SaveOperationsListRequest = z.infer<typeof saveOperationsListRequestSchema>;

/** A captured list value: the code and the words at the time (domain rule 9). */
export const capturedListValueSchema = z.object({ code: z.string(), display: z.string() });
export type CapturedListValue = z.infer<typeof capturedListValueSchema>;
